import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { TopNav } from 'transfix-ui/components/TopNav'
import { useQueryParams, BooleanParam } from 'use-query-params'
import { Container } from 'components/layout'
import { DedicatedLanesBidSubpage } from './DedicatedLanesBidSubpage'

export const DedicatedLanesBidPage = () => {
  const { laneId } = useParams<{ laneId: string }>()
  const [{ mobileApp }] = useQueryParams({ mobileApp: BooleanParam })
  const history = useHistory()
  const backButtonHandler = () => history.goBack()

  return mobileApp ? (
    <DedicatedLanesBidSubpage laneId={laneId} />
  ) : (
    <>
      <TopNav title='Dedicated Lane' showBackButton onPressBackButton={backButtonHandler} />
      <Container hidePadding>
        <DedicatedLanesBidSubpage laneId={laneId} />
      </Container>
    </>
  )
}
